import axios from 'axios'

export const getAgencies = (params) => {
  return axios.get('agencies', { params: params })
}

export const getAgency = (params) => {
  return axios.get('agency/show', { params: params })
}

export const createAgency = (data) => {
  return axios.post('agency/create', data)
}

export const editAgency = (id, data) => {
  return axios.post('agency/edit/' + id, data)
}

export const deleteAgency = (id) => {
  return axios.post('agency/delete/' + id)
}



// WEBPACK FOOTER //
// ./src/api/agencies.js